import { Certification as CertificationDto } from "src/app/proxy/certifications/models";

export class Certification {
  id: number;
  projectId: number;
  roadId: number;
  userId: number;
  user: string;
  originId: string;
  date: string;
  isRejected: boolean;
  version: number;
  operation: string;
  authorizationStateId: number;
  pendingSend: boolean;

  constructor(dto: CertificationDto) {
    Object.assign(this, dto);
  }
}
